import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import { FetchModalID } from "src/ipm-shared/components/GlobalUI/actions";

import AccountSettings from "src/bepaid/layouts/Menu/components/AccountSettings";
import MainLayout from "src/bepaid/layouts/MainLayout";

import styles from "./AccountSettingsModal.module.scss";

const View = (props: any) => {
  const toggleModal = () => {
    props.toggleModal(FetchModalID.UPDATE_ACCOUNT_SETTINGS);
  };

  const onSaved = () => {
    toggleModal();
  };

  const renderContent = () => (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <AccountSettings onSaved={onSaved} />
      </div>
    </div>
  );

  return (
    <>
      <BrowserView>
        <DesktopModalLayout title={"Fetch settings"} onClose={toggleModal}>
          {renderContent()}
        </DesktopModalLayout>
      </BrowserView>
      <MobileView>
        <MainLayout
          header={{
            title: "Fetch settings",
            hideMenu: true,
            onClose: toggleModal
          }}
        >
          {renderContent()}
        </MainLayout>
      </MobileView>
    </>
  );
};

export default View;
